import { render } from "./MaterialTextarea.vue?vue&type=template&id=28c6c065"
import script from "./MaterialTextarea.vue?vue&type=script&lang=js"
export * from "./MaterialTextarea.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__